declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

export const GA_HIT_TIMEOUT_MS = 1000;

const DEFAULT_LEAVE_EVENT = { event: "lp_page_leave" };

export const pushDataLayerEvent = (
  event: Record<string, any>,
  timeoutMs = GA_HIT_TIMEOUT_MS,
) =>
  new Promise<void>((resolve) => {
    if (typeof window === "undefined") {
      resolve();
      return;
    }

    window.dataLayer = window.dataLayer || [];
    let resolved = false;
    const resolveOnce = () => {
      if (resolved) return;
      resolved = true;
      resolve();
    };

    window.dataLayer.push({
      ...event,
      eventCallback: resolveOnce,
      eventTimeout: timeoutMs,
    });

    window.setTimeout(resolveOnce, timeoutMs);
  });

export const pushDataLayerEventSync = (event: Record<string, any>) => {
  if (typeof window === "undefined") {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
};

export const flushEngagementThen = async (
  url: string,
  event: Record<string, any> = DEFAULT_LEAVE_EVENT,
) => {
  await pushDataLayerEvent(event);
  if (typeof window !== "undefined") {
    window.location.href = url;
  }
};

let pageHideInstalled = false;

export const installPageHideTracking = () => {
  if (typeof window === "undefined" || pageHideInstalled) {
    return;
  }

  pageHideInstalled = true;

  const fire = () => {
    pushDataLayerEventSync({ event: "lp_page_hide" });
  };

  window.addEventListener("pagehide", fire);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      fire();
    }
  });
};
